import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Icon,
  useToast,
  Text,
} from '@chakra-ui/react'
import { useEffect, useRef } from 'react'
import { Button } from '../../../../../../components/Button'
import { api } from '../../../../../../services/api'
import { useMutation, useQueryClient } from 'react-query'
import { useOrcamentoPedido } from '../../../../../../contexts/OrcamentoPedidoProvider'
import { useForm, Controller } from 'react-hook-form'
import { IoIosSend } from 'react-icons/io'
import { format } from 'date-fns'

import ReactQuill from 'react-quill'
import 'quill-paste-smart'
import { EnviarProposta24Horas } from '../EnviarProposta24Horas'

const modules = {
  toolbar: ['bold', 'italic', 'underline'],
}

const formats = [
  'background',
  'bold',
  'color',
  'font',
  'code',
  'italic',
  'link',
  'size',
  'strike',
  'script',
  'underline',
  'blockquote',
  'header',
  'indent',
  'list',
  'align',
  'direction',
  'code-block',
  'formula',
  'image',
  'video',
]

async function enviarProposta({ numeroNota, observacao }) {
  const response = await api.post('/site/v2/orcamento-crm/envia-proposta-crm', {
    numero_nota: numeroNota,
    observacao,
  })

  return response.data
}

export function EnviarProposta() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { infoProposta, itens } = useOrcamentoPedido()
  const cancelRef = useRef()

  const queryClient = useQueryClient()

  const { handleSubmit, setValue, control } = useForm()

  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  })
  const { mutateAsync: handleEnviarProposta, isLoading } = useMutation({
    mutationFn: enviarProposta,
    onSuccess: (data) => {
      toast({
        title: 'Proposta enviada com sucesso',
        status: 'success',
      })

      queryClient.setQueryData(['items', infoProposta.num_proposta], (oldData) => {
        return {
          ...oldData,
          informacao_da_proposta: {
            ...oldData.informacao_da_proposta,
            cliente: {
              ...oldData.informacao_da_proposta.cliente,
              data_retorno: format(new Date(data.data_retorno), 'dd/MM/yyyy'),
            },
            id_funil: data.id_funil,
          },
        }
      })

      onClose()
    },
    onError: (error) => {
      toast({
        title: 'Erro ao enviar proposta',
        description: error.response.data.erros,
        status: 'error',
      })
    },
  })

  async function onSubmit(data) {
    const { motivo } = data

    const hasItemTravado = itens.some((item) => item.trava_item)

    if (hasItemTravado) {
      toast({
        title: 'Não foi possivel enviar a proposta',
        description: 'Existem itens que precisam ser editados, por favor, verifique os itens.',
        status: 'error',
      })

      return
    }

    await handleEnviarProposta({ numeroNota: infoProposta.num_proposta, observacao: motivo })
    onClose()
  }

  useEffect(() => {
    if (!infoProposta.observacao_email) {
      setValue(
        'motivo',
        `Olá ${infoProposta?.nome_contato}, Conforme solicitado, segue anexo nossa proposta comercial. Caso tenha qualquer dúvida ou necessite de maiores informações não deixe de me contatar. Qualquer dúvida, estou à sua inteira disposição. Atenciosamente, ${infoProposta?.nome_vendedor}.`
      )
    } else {
      setValue('motivo', infoProposta.observacao_email)
    }
  }, [infoProposta, setValue])

  return <EnviarProposta24Horas />

  return (
    <>
      <Button
        onClick={onOpen}
        border={0}
        borderRadius={0}
        disabled={infoProposta?.valida_proposta_nova}
        bgColor="transparent"
        px={3}
        py={2}
        color="#2D2D2D"
        _hover={{
          bg: '#e2e2e2',
        }}
        fontWeight="normal"
        leftIcon={<Icon as={IoIosSend} fontSize="20px" color="#378BBF" />}
      >
        Enviar Proposta
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} size="2xl">
        <AlertDialogOverlay>
          <AlertDialogContent as="form" onSubmit={handleSubmit(onSubmit)}>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Enviar Proposta
            </AlertDialogHeader>

            <AlertDialogBody>
              Tem certeza que deseja enviar a proposta?
              <Text display="block" mt={4} fontSize="sm" fontWeight="bold" as="label" htmlFor="descrição">
                Observação
              </Text>
              {/* <Textarea
                id="descrição"
                placeholder="Observação da proposta"
                resize={'none'}
                rows={5}
                borderRadius={0}
                sx={{
                  '&::placeholder': {
                    color: '#929292'
                  }
                }}
                borderColor="#a1a1a1"
                _focus={{
                  borderColor: 'black'
                }}
                {...register('motivo')}
              /> */}
              <Controller
                control={control}
                defaultValue=""
                rules={{ required: 'Campo obrigatório' }}
                name="motivo"
                render={({ field }) => (
                  <ReactQuill theme="snow" {...field} style={{ height: '100px', marginBottom: '60px' }} modules={modules} formats={formats} />
                )}
              />
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} bgColor="red.500" onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme="red" bgColor="blue.500" type="submit" isLoading={isLoading} ml={3}>
                Confirmar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
